export default "__VITE_ASSET__64b01d3c__"